function getUrlParameter(name) {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(location.search)
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

function navigateToUrlByCusip(cusip, fundClass) {
  let urlParts = window.location.href.split('?')

  // replacing 'Class-X' in url with selected class (fundClass)
  urlParts[0] = urlParts[0].replace(
    /\/Class-.*?\//,
    '/Class-' + fundClass + '/'
  )

  window.location.href = [urlParts[0], '?cusip=', cusip].join('')
}

function adjustCWPMappedUrl(pageName, cusip) {
  const url = window.location.href
  const urlParts = url.split('/')

  if (
    urlParts.length < 5 ||
    (url.indexOf('localhost') >= 0 && urlParts.length < 7)
  ) {
    // if the url isn't long enough, safely return it.
    return url
  }

  const prefix = url.split('?')[0]
  const hasSlash = prefix
    ? prefix.lastIndexOf('/') === prefix.length - 1
    : false
  let mappedUrl = ''

  for (let i = 0; i < urlParts.length; i++) {
    const part = urlParts[i]

    // add page name to the end of url, but make sure it replaces the last wildcard.
    if (i === urlParts.length - 2) {
      mappedUrl += hasSlash ? pageName : `${part}/${pageName}`
      mappedUrl += `/?cusip=${cusip}`
      break
    } else {
      mappedUrl += part + '/'
    }
  }

  return mappedUrl
}

function isPdfUrl(docURL) {
  if (docURL) {
    const _docURL = docURL.toLowerCase()

    return (
      _docURL.indexOf('.pdf') >= 0 ||
      _docURL.indexOf('rightprospectus.com') >= 0
    )
  }
  return false
}

export { getUrlParameter, navigateToUrlByCusip, adjustCWPMappedUrl, isPdfUrl }
